import { useField } from "formik";
import { Editor } from "neetoeditor";

import Checkbox from "./Checkbox";
import DragHandle from "./DragHandle";
import OptionActions from "./OptionActions";

const EditorOption = ({
  innerRef,
  draggableProps,
  dragHandleProps,
  isDraggable,
  optionIndex,
  isCheckboxEnabled,
  name,
  disabled,
  placeholder,
  shouldFocus,
  onChange,
  onBlur,
  id,
  arrayHelpers,
  hideCloneOption,
  hideDeleteOption,
  onClone,
  onDelete,
}) => {
  const [field] = useField(name);

  return (
    <div
      ref={innerRef}
      {...{ ...draggableProps, ...dragHandleProps }}
      data-testid="form-block-options"
    >
      <div className="nf-input-options group relative mb-2 flex items-start gap-1">
        {isDraggable && (
          <DragHandle
            {...dragHandleProps}
            data-testid={`drag-handle-${optionIndex}`}
          />
        )}
        {isCheckboxEnabled && <Checkbox {...{ name, optionIndex }} />}
        <div className="flex w-full items-start gap-2">
          <Editor
            {...{ disabled, name, placeholder }}
            autoFocus={shouldFocus}
            className="flex-1"
            data-testid={`editor-option-${optionIndex}`}
            initialValue={field.value}
            onChange={value => onChange({ id, value })}
            onBlur={value => {
              onChange({ id, value, isOnBlur: true });
              onBlur?.(id, value);
            }}
          />
          <div className="absolute end-2 top-2">
            <OptionActions
              {...{
                arrayHelpers,
                disabled,
                hideCloneOption,
                hideDeleteOption,
                id,
                onClone,
                onDelete,
                optionIndex,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorOption;
